import type { SVGProps } from 'react';

export function WyrmIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m13.2 7.069-1.946-.488a.595.595 0 0 1-.45-.517.61.61 0 0 1 .326-.604l1.53-.765-1.624-1.219A.598.598 0 0 1 11.4 2.4h6c1.133 0 2.201.532 2.88 1.44l2.16 2.88A1.8 1.8 0 0 1 21 9.6h-.806a2.4 2.4 0 0 1-1.699-.701l-.499-.5h-1.2v.807c0 .93.48 1.796 1.268 2.291l3.997 2.498a4.117 4.117 0 0 1-2.182 7.609L1.21 21.6A1.208 1.208 0 0 1 .05 20.047c.105-.345.36-.626.697-.765q.17-.07.357-.082l15.146-1.35a.604.604 0 0 0 .375-1.031l-1.665-1.665a6 6 0 0 1-1.759-4.242zm6-1.958V5.09zm-.049.278-1.74-.435a.898.898 0 0 0 1.74.435M4.91 6.769a1.8 1.8 0 0 1 2.194-.154L12 9.877v1.032c0 1.23.315 2.43.9 3.487H4.2a.6.6 0 0 1-.562-.39.6.6 0 0 1 .172-.664l2.602-2.23-5.722.88a.599.599 0 0 1-.487-1.042z" />
    </svg>
  );
}
